import React from 'react';

import {
	useIsDigimarcCorrect,
	useIsQrCodeRecognized,
} from '../../store/scanSession/selectors';
import Counterfeit from './Counterfeit';
import Success from './Success';
import TamperTesterHeader from '../../components/TamperTesterHeader';
import Tampering from './Tampering';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

const Buttons = ({ children, ...props }) => {
	const theme = useTheme();
	return (
		<Grid
			container
			spacing={1}
			style={{ margin: theme.spacing(4, 0) }}
			{...props}
		>
			{React.Children.toArray(children).map((child) => (
				<Grid item xs={12}>
					{child}
				</Grid>
			))}
		</Grid>
	);
};

const Content = ({ children, ...props }) => {
	return (
		<Grid container spacing={3} {...props}>
			{children}
		</Grid>
	);
};

function VerificationResults() {
	const isQrRecognized = useIsQrCodeRecognized();
	const isDigimarcCorrect = useIsDigimarcCorrect();

	let Page;
	if (isQrRecognized && isDigimarcCorrect) {
		Page = Success; // only show success if success is guaranteed
	} else if (isQrRecognized) {
		Page = Tampering;
	} else {
		Page = Counterfeit;
	}

	return (
		<>
			<TamperTesterHeader />
			<Container maxWidth="sm">
				<Page Content={Content} Buttons={Buttons} />
			</Container>
		</>
	);
}

export default VerificationResults;
